/* Action types with TypeScript type declaration */

export const SET_CONTENT = 'rpb2b-react/tracking/SET_CONTENT';
export type SET_CONTENT = typeof SET_CONTENT;

export const GET_TRACKING_IS_PENDING =
  'rpb2b-react/tracking/GET_TRACKING_IS_PENDING';
export type GET_TRACKING_IS_PENDING = typeof GET_TRACKING_IS_PENDING;

export const SET_DATES_FILTER = 'rpb2b-react/tracking/SET_DATES_FILTER';
export type SET_DATES_FILTER = typeof SET_DATES_FILTER;

export const CLEAR_ALL = 'rpb2b-react/tracking/CLEAR_ALL';
export type CLEAR_ALL = typeof CLEAR_ALL;

export const TRACKING_ERROR = 'rpb2b-react/tracking/TRACKING_ERROR';
export type TRACKING_ERROR = typeof TRACKING_ERROR;

export const TRACKING_PAGINATION = 'rpb2b-react/tracking/TRACKING_PAGINATION';
export type TRACKING_PAGINATION = typeof TRACKING_PAGINATION;

export default {
  SET_CONTENT,
  GET_TRACKING_IS_PENDING,
  SET_DATES_FILTER,
  CLEAR_ALL,
  TRACKING_ERROR,
  TRACKING_PAGINATION
};
